<script setup lang="ts">
import type { RouteNamedMapI18n } from 'vue-router/auto-routes'

const { t } = useI18n()
const localePath = useLocalePath()

const props = defineProps<{
  link: {
    name: keyof RouteNamedMapI18n
    slug: string | undefined
    labelPath: string
  }
}>()
</script>

<template>
  <NuxtLink
    :to="
      localePath({ name: props.link.name, params: { slug: props.link.slug } })
    "
    class="group my-auto w-max whitespace-nowrap font-bold no-underline transition duration-300"
  >
    <div>
      {{ t(props.link.labelPath) }}
      <span
        class="-mt-1 block h-[1px] max-w-0 bg-black transition-all duration-500 group-hover:max-w-full"
        :class="{
          '!max-w-full':
            $route.path ===
            localePath({
              name: props.link.name,
              params: { slug: props.link.slug },
            }),
        }"
      />
    </div>
  </NuxtLink>
</template>
